import { getTokenFromCookie } from '~/utils/getTokenFromCookie'
import { gql } from '@apollo/client'

export const GET_LOGGED_IN_USER = gql`
  query getLoggedInUserInfo {
    loggedInUser {
      id
      intercomVerificationId
      city
      locationCountryCode
      avatar
      firstname
      lastname
      successfullySoldCount
      isEmployee
      hasAgreedToLatestTermsAndPrivacyPolicy
      createdAt
      email
      isPhoneVerified
      isEmailVerified
      isPartner
      isTicketProvider
      hasConversations
      facebookUserPermissions {
        handle
        granted
      }
      facebookAccount {
        friendsCount
      }
      twitterAccount {
        id
      }
      cart {
        id
      }
      locale
      userDevices {
        name
      }
      notificationInboxMessages: NotificationInboxMessages {
        unreadMessageCount
      }
    }
  }
`

const getLoggedInUser = async (apolloClient, req) => {
  const token = getTokenFromCookie(req)

  try {
    const { data } = await apolloClient.query({
      query: GET_LOGGED_IN_USER,
      skip: !token,
    })

    if (data.loggedInUser !== null) {
      return data.loggedInUser
    }
  } catch {}

  return null
}

export default getLoggedInUser
